let idCount = 0;

/**
 * Dead simple unique ID implementation.
 * Thanks lodash!
 * @return {number}
 */
function uniqueId () {
  return ++idCount;
}

export default uniqueId;
